import metadatas from 'libphonenumber-js/metadata.min.json'

export const COUNTRIES = metadatas.countries

export const ISO_CODES = Object.keys(COUNTRIES)

export const DEFAULT_ISO_CODE = 'US'

export const DEFAULT_LANG = 'en'
